var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTherapyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_752_72059)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_72059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8196 16.9218C36.3018 16.8888 35.9085 17.3012 35.8196 17.8123C35.598 19.0865 35.1131 21.4066 35.1131 21.4066L35.113 21.4067C35.0753 21.2672 34.9953 21.1312 34.859 21.004C34.4418 20.6148 33.6564 20.984 32.8684 21.5618C31.4911 22.4659 31.1287 22.9008 30.2842 23.1091C29.84 23.2186 29.117 23.4694 28.277 24.0387C26.8956 24.975 26.3095 26.9626 26.5135 28.4127C26.6313 29.2494 26.59 29.8995 26.5982 30.4804H31.1173L31.1167 29.5018C31.1166 29.3347 31.2135 29.1825 31.3656 29.1134C32.2311 28.7204 34.6075 27.3392 35.981 25.8697C37.0714 24.7031 37.6481 20.4006 37.7315 18.0403C37.7522 17.4536 37.4037 16.959 36.8196 16.9218Z",
    fill: "url(#paint1_linear_752_72059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9177 21.083C35.8899 20.969 35.7576 20.5002 35.3893 20.0566C35.2377 20.8103 35.113 21.4064 35.113 21.4064L35.1129 21.4065C35.1317 21.7458 35.0093 22.8321 33.1736 24.0033C31.0666 25.3477 31.0607 25.3748 31.0152 25.5854C30.9248 26.0033 31.4418 26.2896 31.746 25.9791C31.8078 25.9308 32.1324 25.6923 33.6382 24.7315C36.3383 23.0088 35.9671 21.2699 35.9177 21.083Z",
    fill: "#EEE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1996 29.2508C29.5558 30.0919 27.5181 29.5793 26.4777 28.0078C26.4832 28.1466 26.495 28.2823 26.5134 28.4135C26.6311 29.2503 26.5899 29.9004 26.598 30.4813H31.1172C31.1411 29.5574 31.0591 29.4436 31.1996 29.2508Z",
    fill: "#F2E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0631 32.504H25.8705V30.7021C25.8705 30.516 26.0214 30.3652 26.2075 30.3652H31.7262C31.9123 30.3652 32.0631 30.5161 32.0631 30.7021V32.504Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4945 33.8896H24.6099V32.6744C24.6099 32.549 24.4122 32.4473 24.1683 32.4473H16.936C16.6921 32.4473 16.4945 32.549 16.4945 32.6745V33.8896Z",
    fill: "#F16480",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 33.8896H33.1154V32.6744C33.1154 32.549 32.9177 32.4473 32.6738 32.4473H25.4415C25.1976 32.4473 25 32.549 25 32.6745V33.8896Z",
    fill: "#F16480",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6996 16.9218C13.2174 16.8888 13.6106 17.3012 13.6995 17.8123C13.9212 19.0865 14.4061 21.4066 14.4061 21.4066L14.4062 21.4067C14.4438 21.2672 14.5239 21.1312 14.6601 21.004C15.0773 20.6148 15.8628 20.984 16.6508 21.5618C18.0281 22.4659 18.3904 22.9008 19.2349 23.1091C19.6791 23.2186 20.4022 23.4694 21.2422 24.0387C22.6236 24.975 23.2097 26.9626 23.0056 28.4127C22.8886 29.2443 22.9298 29.883 22.921 30.4804H18.4018L18.4024 29.5018C18.4025 29.3347 18.3057 29.1825 18.1535 29.1134C17.288 28.7204 14.9116 27.3392 13.5381 25.8697C12.4479 24.7033 11.8711 20.4007 11.7877 18.0405C11.767 17.4536 12.1154 16.959 12.6996 16.9218Z",
    fill: "url(#paint2_linear_752_72059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6015 21.083C13.6293 20.969 13.7616 20.5002 14.1299 20.0566C14.2816 20.8103 14.4062 21.4064 14.4062 21.4064L14.4063 21.4065C14.3875 21.7458 14.51 22.8321 16.3456 24.0033C18.4527 25.3477 18.4586 25.3748 18.5041 25.5854C18.5945 26.0033 18.0775 26.2896 17.7733 25.9791C17.7114 25.9308 17.3869 25.6923 15.881 24.7315C13.1809 23.0088 13.5521 21.2699 13.6015 21.083Z",
    fill: "#EEE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3196 29.2508C19.9634 30.0919 22.0012 29.5793 23.0416 28.0078C23.036 28.1466 23.0243 28.2823 23.0058 28.4135C22.8888 29.2452 22.93 29.8839 22.9212 30.4813H18.402C18.3781 29.5574 18.4602 29.4436 18.3196 29.2508Z",
    fill: "#F2E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4561 32.506H23.6486V30.7041C23.6486 30.518 23.4978 30.3672 23.3117 30.3672H17.7929C17.6069 30.3672 17.4561 30.518 17.4561 30.7041V32.506Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0339 21.6408C24.9067 23.4463 20.8937 22.3709 19.0881 19.2438C17.2827 16.1165 18.358 12.1035 21.4852 10.298C24.6124 8.49243 28.6254 9.56778 30.431 12.695C32.2364 15.8222 31.1612 19.8352 28.0339 21.6408Z",
    fill: "url(#paint3_linear_752_72059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0653 9.38304C28.548 9.62598 27.781 10.7221 27.781 11.9197V15.8892C27.781 17.6333 26.51 18.1848 25.6403 18.3581C25.6005 18.366 25.5634 18.336 25.5634 18.2954V10.4025C25.5634 9.21809 26.6576 8.82296 26.8789 8.74838C26.9214 8.73408 26.9498 8.69452 26.9498 8.64974V8.62118C26.9498 8.5575 26.8982 8.50586 26.8345 8.50586L22.8438 8.50586C22.7858 8.50586 22.7388 8.55286 22.7388 8.61085V8.64969C22.7388 8.69452 22.7673 8.73403 22.8097 8.74833C23.0311 8.82296 24.1253 9.21814 24.1253 10.4024V18.2954C24.1253 18.3359 24.0881 18.3659 24.0484 18.358C23.1787 18.1847 21.9076 17.6333 21.9076 15.8892V11.9197C21.9076 10.722 21.1405 9.62577 19.6229 9.38299C19.4692 9.35841 19.3843 9.55295 19.5047 9.6516C19.8921 9.96911 20.3483 10.5621 20.3483 11.5942V15.8893C20.3483 15.8893 20.3947 18.4492 24.0665 18.7672C24.0995 18.7701 24.1252 18.7975 24.1252 18.8308L24.1252 23.1181C24.1252 23.2627 24.008 23.38 23.8633 23.38C23.6668 23.38 23.4954 23.5315 23.4895 23.728C23.4834 23.9312 23.6464 24.0979 23.8482 24.0979H25.8251C26.0217 24.0979 26.1931 23.9464 26.199 23.75C26.205 23.5467 26.0421 23.3801 25.8402 23.3801C25.6873 23.3801 25.5634 23.2561 25.5634 23.1032L25.5634 18.8308C25.5634 18.7977 25.589 18.7702 25.6221 18.7673C29.294 18.4492 29.3403 15.8893 29.3403 15.8893V11.5943C29.3403 10.5621 29.7967 9.96911 30.184 9.6516C30.3042 9.5529 30.2189 9.35846 30.0653 9.38304Z",
    fill: "#D4648A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_72059",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 45.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_72059",
    x1: 32.1032,
    y1: 16.9199,
    x2: 32.1032,
    y2: 30.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_72059",
    x1: 17.416,
    y1: 16.9199,
    x2: 17.416,
    y2: 30.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_72059",
    x1: 24.7596,
    y1: 9.42187,
    x2: 24.7596,
    y2: 22.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F490A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_72059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4423,
    height: 26.4423,
    fill: "white",
    transform: "translate(11.5385 8.50586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapyIcon);
export default __webpack_public_path__ + "static/media/therapy-icon.42c758e70aa162ee1c95473ab7fde4c1.svg";
export { ForwardRef as ReactComponent };